import apiApp from "./index";
const token = localStorage.getItem("UserjwtToken");
const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));

const switched = localStorage.getItem("switched");
const switchedSubtenant = JSON.parse(localStorage.getItem("switchedSubtenant"));
// helper: return query param if subTenantId exists
const getSubTenantIdParam = () => {
    if (decodedToken?.isMultitenancy && decodedToken?.subTenantId !== undefined) {
        const subTenantId = decodedToken?.subTenantId;
        return subTenantId ? `&subTenantId=${subTenantId}` : "";
    } else if (switched && switchedSubtenant) {
        return `&subTenantId=${switchedSubtenant?.id}`;
    }
    return "";
};

// Helper for request body
const getSubTenantDTO = () => {
  return decodedToken?.isMultitenancy && decodedToken?.subTenantId
    ? { id: decodedToken.subTenantId }
    : null;
};

// Common headers
const getHeaders = () => {
  const headers = {
    Authorization: `Bearer ${token}`,
    "x-Authorization": `${decodedToken?.tenantApiKey}`,
  };

  if (decodedToken?.roles?.includes("TENANT_ADMIN") || decodedToken?.subTenantId === undefined) {
    headers["tenant-login"] = true;
  }

  return headers;
};

const StockLevelApi = {
  // Create Stock Level Api
  CreateStockLevel: (data) => {
    const jsonData = typeof data === "string" ? JSON.parse(data) : data;
    const subTenantDTO = getSubTenantDTO();
    if (subTenantDTO) jsonData.subTenantDTO = subTenantDTO;
    data = JSON.stringify(jsonData);

    return new Promise((resolve, reject) => {
      apiApp
        .post(`/stockLevel`, data, { headers: getHeaders() })
        .then((response) => resolve(response.data))
        .catch((error) => reject(error?.response?.data));
    });
  },

  // List Stock Production Api
  ListStockProduction: (StockID) => {
    return new Promise((resolve, reject) => {
      apiApp
        .get(
          `/stockLevel/production/${StockID}?size=100&tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
          { headers: getHeaders() }
        )
        .then((response) => resolve(response.data))
        .catch((error) => reject(error?.response?.data));
    });
  },
};

export default StockLevelApi;
